import * as React from "react"
import { Link, usePage } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { cn } from "@/lib/utils"
import type { PageProps } from "@/types/inertia"

type SettingsTabDef = {
  href: string
  label: string
  adminOnly?: boolean
  match: (url: string) => boolean
}

const SETTINGS_TABS: SettingsTabDef[] = [
  {
    href: "/settings",
    label: "General",
    match: (url) => url === "/settings",
  },
  {
    href: "/settings/clients",
    label: "Clients",
    adminOnly: true,
    match: (url) => url.startsWith("/settings/clients"),
  },
  {
    href: "/settings/classifier",
    label: "Classifier",
    adminOnly: true,
    match: (url) => url.startsWith("/settings/classifier"),
  },
  {
    href: "/settings/checklist_templates",
    label: "Checklist templates",
    adminOnly: true,
    match: (url) => url.startsWith("/settings/checklist_templates"),
  },
]

export function SettingsLayout({
  children,
  wide = false,
}: {
  children: React.ReactNode
  wide?: boolean
}) {
  const { url, props } = usePage<PageProps>()
  const isAdmin = props.current_user?.admin ?? false
  const tabs = SETTINGS_TABS.filter((tab) => !tab.adminOnly || isAdmin)

  return (
    <AppShell wide={wide}>
      <div className="flex flex-col gap-6">
        <nav
          className="flex flex-wrap gap-1 border-b border-hairline"
          aria-label="Settings sections"
        >
          {tabs.map((tab) => {
            const active = tab.match(url)
            return (
              <Link
                key={tab.href}
                href={tab.href}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "-mb-px border-b-2 px-3 py-2 text-sm no-underline transition-colors",
                  active
                    ? "border-accent text-accent-display"
                    : "border-transparent text-ink-body hover:text-ink-display",
                )}
              >
                {tab.label}
              </Link>
            )
          })}
        </nav>
        {children}
      </div>
    </AppShell>
  )
}
